import script from "./TopBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TopBar.vue?vue&type=script&setup=true&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=75fbce6e&lang=scss&scoped=true"

import exportComponent from "C:\\AQRepo\\customermanagedinspection_fe-brands-kra-norden\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75fbce6e"]])

export default __exports__